import { render, staticRenderFns } from "./recommendPageNoConfig.vue?vue&type=template&id=e08bfa54&scoped=true&"
import script from "./recommendPageNoConfig.vue?vue&type=script&lang=js&"
export * from "./recommendPageNoConfig.vue?vue&type=script&lang=js&"
import style0 from "./recommendPageNoConfig.vue?vue&type=style&index=0&id=e08bfa54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08bfa54",
  null
  
)

export default component.exports